import BaseObject, { BaseObjectParams } from './baseObject';
import Game from './game';
import LevelScene from './scene/LevelScene';
import Scene from './scene/scene';

export interface WarFogParams extends BaseObjectParams {
  ctx: CanvasRenderingContext2D;
  width: number;
  height: number;
  color?: string;
  sizeRatio?: number;
}

export default class WarFog extends BaseObject implements WarFogParams {
  ctx!: CanvasRenderingContext2D;
  width!: number;
  height!: number;
  sizeRatio = 1 / 20; // size of the warfog canvas compared to the whole scene (for performances)
  color = '#111';

  temporaryCanvas: HTMLCanvasElement;
  temporaryCtx: CanvasRenderingContext2D | null;

  get scene() {
    return Game.instance.scene as LevelScene;
  }

  constructor(params: WarFogParams) {
    super();
    this.applyParams(params);

    this.temporaryCanvas = document.createElement('canvas');
    this.temporaryCanvas.width = this.width * this.sizeRatio;
    this.temporaryCanvas.height = this.height * this.sizeRatio;
    this.temporaryCtx = this.temporaryCanvas.getContext('2d');

    if (!this.temporaryCtx) {
      throw new Error('Could not get 2D rendering context');
    }

    /* Initial Draw */
    this.temporaryCtx.fillStyle = this.color;
    this.temporaryCtx.fillRect(0, 0, this.temporaryCanvas.width, this.temporaryCanvas.height);
  }

  draw(): void {
    if (!this.temporaryCtx) return;

    const { ctx, temporaryCanvas, scene } = this;
    const { camera } = scene;
    ctx.save();
    ctx.drawImage(
      temporaryCanvas,
      camera.leftX * this.sizeRatio, camera.topY * this.sizeRatio,
      camera.width * this.sizeRatio, camera.height * this.sizeRatio,
      camera.leftX, camera.topY,
      camera.width, camera.height,
    );
    ctx.restore();
  }

  clearArc(params: {
    x: number,
    y: number,
    radius: number,
    startAngle: number,
    endAngle: number,
  }): void {
    if (!this.temporaryCtx) return;

    const { x, y, radius, startAngle, endAngle } = params;
    const { temporaryCtx: ctx } = this;
    const revealGradient = ctx.createRadialGradient(x * this.sizeRatio, y * this.sizeRatio, 0, x * this.sizeRatio, y * this.sizeRatio, radius * this.sizeRatio);
    revealGradient.addColorStop(0, '#FFF');
    revealGradient.addColorStop(1, 'transparent');

    ctx.save();
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = revealGradient;
    ctx.beginPath();
    ctx.arc(x * this.sizeRatio, y * this.sizeRatio, radius * this.sizeRatio, startAngle, endAngle);
    ctx.fill();
    ctx.restore();
  }
}
